var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheHaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.102 17.688c-1.986 1.982-3.686 3.725-3.779 3.873-.285.456.038 1.022.583 1.022.274 0 .49-.196 3.36-3.06l3.067-3.06v9.509c0 9.071.007 9.518.152 9.697.215.265.815.265 1.03 0 .145-.179.152-.626.152-9.697v-9.509l3.067 3.06c3.33 3.323 3.286 3.289 3.787 2.895.301-.236.354-.539.153-.861-.091-.146-1.79-1.887-3.776-3.869-3.361-3.355-3.631-3.605-3.898-3.605-.267 0-.537.25-3.898 3.605",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheHaut);
export default __webpack_public_path__ + "static/media/fleche-haut.92d147788e20ad7c56d3b747bb675d57.svg";
export { ForwardRef as ReactComponent };